/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { getColor } from "utils/colors";

const formatActividad = (actividad) => {
  const actividadMap = {
    Generadora: "Generadora",
    GeneradoraOperadora: "Generadora/Operadora",
    Operadora: "Operadora",
    "Operador in situ": "Operador in situ",
    RecicladoraOperadora: "Recicladora/Operadora",
    Transportista: "Transportista",
    GeneradorComercioServicio: "Generador Comercio/Servicio",
  };

  if (actividad) {
    return actividadMap[actividad] || actividad;
  }
  return null;
};

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        razonSocial: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.razonSocial}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.razonSocial}
            </SoftTypography>
          </SoftBox>
        ),
        cuit: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.cuit}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.cuit}
            </SoftTypography>
          </SoftBox>
        ),
        email: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.email}
            </SoftTypography>
          </SoftBox>
        ),
        actividad: (
          <SoftBox>
            {(item?.actividad || []).map((actividad, index) => (
              <SoftTypography
                key={`${actividad}-${index}`}
                component="div"
                variant="caption"
                color="dark"
                fontWeight="medium"
              >
                {formatActividad(actividad)}
              </SoftTypography>
            ))}
          </SoftBox>
        ),
        estado: (
          <SoftBadge size="xs" variant="contained" container
            color={item.estado === "Irregular" ? "error" : "success"}
            badgeContent={item.estado === "Irregular" ? "Estado irregular" : "Estado regular"} />
        ),
        responsable: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.responsableTecnico
                ? item?.responsableTecnico?.nombre + " " + item?.responsableTecnico?.apellido
                : "No asignado"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "id", desc: "Legajo", align: "center" },
  { name: "razonSocial", desc: "Razón Social", align: "left" },
  { name: "cuit", desc: "CUIT", align: "left" },
  { name: "email", desc: "Email", align: "left" },
  { name: "actividad", desc: "Actividad", align: "left", noOrder: true },
  { name: "estado", desc: "Estado", align: "center" },
  { name: "responsable", desc: "Res. Técnico", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
